import { motion } from "framer-motion";

const LOGOS = [
  { name: "Audi", src: "https://cdn.simpleicons.org/audi/9CA3AF" },
  { name: "BMW", src: "https://cdn.simpleicons.org/bmw/9CA3AF" },
  { name: "Mercedes-Benz", src: "https://cdn.worldvectorlogo.com/logos/mercedes-benz-9.svg", invert: true },
  { name: "Alfa Romeo", src: "https://cdn.worldvectorlogo.com/logos/alfa-romeo.svg", invert: true },
  { name: "Volkswagen", src: "https://cdn.simpleicons.org/volkswagen/9CA3AF" },
  { name: "Fiat", src: "https://cdn.simpleicons.org/fiat/9CA3AF" },
  { name: "Jeep", src: "https://cdn.simpleicons.org/jeep/9CA3AF" },
  { name: "Ford", src: "https://cdn.simpleicons.org/ford/9CA3AF" },
  { name: "Toyota", src: "https://cdn.simpleicons.org/toyota/9CA3AF" },
  { name: "Renault", src: "https://cdn.simpleicons.org/renault/9CA3AF" },
  { name: "Peugeot", src: "https://cdn.simpleicons.org/peugeot/9CA3AF" },
  { name: "Opel", src: "https://cdn.simpleicons.org/opel/9CA3AF" },
];

const CHAPTERS = [
  {
    n: "01",
    title: "Tradizione & Trasparenza",
    text: "Da anni serviamo Cattolica Eraclea e tutta la provincia di Agrigento con un solo metodo: prezzi chiari, storia del veicolo documentata e zero sorprese.",
  },
  {
    n: "02",
    title: "Qualità Certificata",
    text: "Ogni usato è sottoposto a controlli meccanici e di carrozzeria prima di entrare in vetrina. Chilometraggio certificato e garanzia fino a 24 mesi.",
  },
  {
    n: "03",
    title: "Assistenza Completa",
    text: "Finanziamento, assicurazione e passaggio di proprietà: ci occupiamo di tutta la burocrazia mentre tu pensi solo a guidare.",
  },
];

export const Manifesto = () => (
  <section id="chi-siamo" className="py-16 md:py-24 relative overflow-hidden" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-mono2 text-xs uppercase tracking-[0.35em] text-amber-500 mb-3">03 / Chi Siamo</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight leading-tight">
            Il metodo Manno,<br />dal primo giro di chiave
          </h2>
        </motion.div>
        <div className="mt-10 space-y-8">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="flex gap-6"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <span className="font-display text-5xl font-black text-amber-500/90 leading-none shrink-0">{c.n}</span>
              <div>
                <h3 className="font-display text-xl font-bold uppercase tracking-snug">{c.title}</h3>
                <p className="mt-2 text-sm text-gray-400 leading-relaxed">{c.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="relative"
      >
        <div className="card-frame overflow-hidden border border-border bg-[#0D1119]" data-testid="manifesto-logo-wall">
          <p className="px-6 sm:px-8 pt-6 font-mono2 text-[10px] uppercase tracking-widest text-gray-500">
            Trattiamo le migliori case automobilistiche
          </p>
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 p-6 sm:p-8 pt-4 sm:pt-4 lg:pb-24">
            {LOGOS.map((logo, i) => (
              <motion.div
                key={logo.name}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="aspect-square flex items-center justify-center rounded-lg border border-border bg-[#111622]"
                data-testid={`manifesto-logo-${logo.name.toLowerCase().replace(/[\s-]+/g, "-")}`}
              >
                <img
                  src={logo.src}
                  alt={`Logo ${logo.name}`}
                  loading="lazy"
                  className={`h-10 sm:h-12 w-auto max-w-[70%] object-contain opacity-80 ${
                    logo.invert ? "grayscale invert-[0.85]" : ""
                  }`}
                />
              </motion.div>
            ))}
          </div>
        </div>
        <div className="relative mt-4 lg:mt-0 lg:absolute lg:-bottom-6 lg:-left-6 glass border border-amber-500/30 rounded-xl px-6 py-4 lg:py-5 shadow-2xl w-fit" data-testid="manifesto-stat-card">
          <p className="font-display text-4xl font-black text-amber-500">50+</p>
          <p className="font-mono2 text-[10px] uppercase tracking-widest text-gray-400 mt-1">Veicoli in pronta consegna</p>
        </div>
      </motion.div>
    </div>
  </section>
);
